import { CommonAddinModule } from '@addins/common.module';
import { CoreModule } from '@addins/core/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { Injector, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { Addin, AddinModule } from '@techwan/ionic-core';
import { FusCallcardFormatterSetupService } from './services/executables/fus-callcard-formatter-setup/fus-callcard-formatter-setup.service';
import { UnitActivityFusModelService } from './services/models/unit-activity-fus-model/unit-activity-fus-model.service';
import { MyCardReceivedTimeService } from './services/my-card-received-time/mycard-received-time.service';

const executables = [FusCallcardFormatterSetupService];
const services = [...executables, MyCardReceivedTimeService, UnitActivityFusModelService];

@NgModule({
  exports: [CoreModule, CommonModule, FormsModule, IonicModule, CommonAddinModule],
  imports: [CoreModule, CommonModule, FormsModule, IonicModule, CommonAddinModule],
  providers: [...services, provideHttpClient(withInterceptorsFromDi())]
})
@Addin({
  name: 'Vd144'
})
export class Vd144Module extends AddinModule {
  constructor(injector: Injector) {
    super(injector, [], executables);
  }

  load() {
    super.load();
  }
}
